<template lang="html">


  <div class="wrapper margin-menu">

    <section class="intro column-center -fundacion">
      <h2>La Fundación</h2>
    </section>

    <section class="breadcrumb">
      <nav class="container row-end">
        <router-link to="/">Inicio</router-link>
        <router-link :to="$t('enlaces.lafundacion')">La Fundación</router-link>
      </nav>
    </section>

    <main>

      <div class="container">

        <h2 class="title-intro">
          Comprometidos <strong>con la sociedad</strong>
        </h2>

        <p class="texto-intro">
          La fundación Tomás Pascual y Pilar Gómez-Cuétara se constituyó en 2011 como la Institución sin ánimo de lucro que recoge el legado de la familia empresaria
          <strong>Pascual-Gómez Cuétara.</strong>

        </p>

      </div>


      <div class="white-box -objetivos">
        <div class="container row-start">
          <h2 class="big-title">Objetivo</h2>
        </div>
        <div class="title-container row-end">
          <h3 class="title-destacado">Aportamos nuevas herramientas y recursos capaces de mejorar la calidad de vida de las personas</h3>
        </div>
      </div>
      

      <div class="contenedor-objetivos">

        <div class="container row-between">
          <div class="left">
            <img src="/static/img/personas-objetivo.svg" class="personas-objetivo">
            <h4 class="destacado">Es un proyecto innovador, social y filantrópico, orientado a promover una mayor calidad de vida, tanto en el ámbito de la alimentación y la salud como en el de la vivencia de los Valores Humanos, para lograr equilibrio y felicidad personal.
            </h4>
          </div>
          <div class="right">
            <h4 class="destacado -small">Su objetivo es dar continuidad y fomentar los principios transmitidos por Don Tomás Pascual y Doña Pilar Gómez-Cuétara, quienes siempre han creído que el cultivo de los valores es la clave para construir una sociedad más saludable y honesta.
            </h4>
            <div class="texto">
              <p>La Fundación inició su actuación basándose en dos ejes prioritarios: por una parte, la difusión de mejores hábitos de alimentación, a través del Instituto Tomás Pascual Sanz, cuyo objetivo es el de generar y difundir actividades de divulgación, estudio y análisis científico en el ámbito de la nutrición, los correctos hábitos de vida y la salud en general. Por otra parte, a través del Centro de Investigación en Valores (CIVSEM), se articulan la investigación, la divulgación y la formación en Valores Humanos como clave para una vida plena, madura y feliz, base del emprendimiento y de la innovación.</p>
              <p>En la actualidad, el Instituto Tomás Pascual Sanz es una entidad dependiente de Corporación Empresarial Pascual.</p>
              </div>
          </div>
        </div>

      </div>

      <div class="white-box -proyectos">
        <div class="container row-start">
          <h2 class="big-title">Proyectos</h2>
        </div>
        <p><strong>La Fundación inició su actuación basándose en dos ejes prioritarios:</strong></p>
        <div class="contenedor-ejes row-between container ais">
          <div class="eje">
            <div class="contenedor-imagen row-center">
            <img src="/static/img/logo-instituto-tomas-pascual.png" alt="Instituto Tomás Pascual Sanz">
          </div>
            <p><strong>El Instituto Tomás Pascual Sanz</strong> nació como una entidad sin ánimo de lucro, con el objetivo de generar y difundir actividades de divulgación, estudios y análisis
              científicos en el ámbito de la alimentación, la nutrición, los hábitos de vida y la salud en general.</p>
              <p>El año 2013 pasó a integrarse orgánicamente en la Corporación Empresarial Pascual con idénticos propósitos que en su creación.</p>
            </p>
          </div>
          <div class="eje">
            <div class="contenedor-imagen row-center">
            <img src="/static/img/civsem-completo.png" alt="Civsem">
          </div>
            <p><strong>A través del Centro de Investigación en Valores (CIVSEM)</strong>, una entidad sin ánimo de lucro, se llevó a cabo una labor dedicada a la investigación, divulgación y formación sobre Valores Humanos, destacando cómo estos favorecen la integración, la convivencia, la superación, la innovación y el sentido de trascendencia de las personas.​</p>
            <p>Su visión fue convertirse en un centro de referencia en el ámbito de los Valores Humanos: generar conocimiento y pedagogía mediante la divulgación, el asesoramiento y la formación, para que quienes lo desearan pudieran construir su vida en torno a profundos Valores; orientar al desarrollo personal y profesional, y prestar especial atención al emprendimiento y a la innovación. Esta labor se mantuvo activa hasta marzo de 2025.</p>
          </div>

          <p><strong>A los que se han ido sumando nuevos proyectos como son:  </strong></p>

          <div class="eje -lateral row-start">
            <div class="contenedor-imagen row-center">
              <img src="/static/img/logo-agua-para-todos.png" alt="Logo agua para todos">
            </div>
            <p>Con el proyecto <strong>Agua para Todos</strong> queremos ayudar a mejorar la calidad de vida de los habitantes de zonas subdesarrolladas a través del acceso a agua potable. Para ello, elegimos proyectos en zonas de alto impacto para las comunidades.</p>
          </div>

          <div class="eje -lateral row-start">
            <div class="contenedor-imagen row-center">
            <img src="/static/img/logo-mide.png" alt="Logo MIDE">
          </div>
          <p><strong>MIDE (Madrid Innovation Driven Ecosystem)</strong> tiene como objetivo desarrollar el ecosistema de emprendimiento e innovación de la región de Madrid con una perspectiva global. Buscamos unificar esfuerzos entre todos en la mejora de la posición competitiva global de Madrid y el impacto generado en términos de innovación y emprendimiento.</p>
          </div>

          <div class="eje -lateral row-start">
            <div class="contenedor-imagen row-center">
            <img src="/static/img/logo-polo.png" alt="Logo polo">
          </div>
          <p>Inicitiva para la aceleración de proyectos. Ayudamos a dar el salto a pequeñas empresas ya constituidas y con potencial de crecimiento.</p>
          </div>

        </div>
      </div>





      <div class="grey-box column-center -gestion-responsable">
        <div class="container column-center">
          <h2 class="title-intro">
            Gestión <strong>Responsable</strong>
          </h2>
          <p>Nuestro compromiso con la calidad exige una política de gestión responsable que abarca toda la cadena de valor, con el objetivo de responder a las expectativas de todos los grupos de interés.</p>

					<p>Este compromiso está recogido en nuestro <a href="/static/pdf/codigo-conducta.pdf" target="_blank" rel="noopener noreferrer">Código de Conducta</a> que persigue extender este concepto de calidad al conjunto de actividades que realizamos. <a href="/static/pdf/codigo-conducta-en.pdf" target="_blank" rel="noopener noreferrer">(See English version of our Code of Conduct)</a></p>

					<p>Además, con el objetivo de definir los principios de gestión responsable en la que nos basamos, ponemos a tu disposición nuestra <a href="/static/pdf/sistemas-gestion.pdf" target="_blank" rel="noopener noreferrer">Política del Sistema de Gestión</a> y las Normas de Gobierno (<a href="/static/pdf/politica-fiscal-corporativa.pdf" target="_blank" rel="noopener noreferrer">Política Fiscal Corporativa</a>, <a href="/static/pdf/politica-de-control.pdf" target="_blank" rel="noopener noreferrer">Política de Control y Gestión de Riesgos</a>, <a href="/static/pdf/politica-de-cumplimiento.pdf" target="_blank" rel="noopener noreferrer">Política de Cumplimiento</a>, <a href="/static/pdf/politica-de-responsabilidad-social.pdf" target="_blank" rel="noopener noreferrer">Política de Responsabilidad Social Corporativa</a>) por las que nos regimos. </p>

					<p>Para conseguir la máxima eficacia en su implantación, aplicamos la metodología del Modelo Europeo de Excelencia (EFQM) y se implantan programas de formación y mejora en gestión y liderazgo.</p>

					<p>Por otro lado, aspiramos a ser referentes dentro de las empresas no cotizadas en la gestión eficiente y excelente de los Órganos de Gobierno Corporativos. Para ello, hemos emprendido un <a href="/static/pdf/codigo-de-buen-gobierno.pdf" target="_blank">proceso para la adecuación a las recomendaciones de Buen Gobierno</a> contenidas en el Código de Buen Gobierno de las Sociedades Cotizadas, aprobado en febrero de 2015.</p>
          <a href="/static/pdf/codigo-conducta.pdf" class="btn with-border">Código de Conducta Responsable</a>
        </div>
      </div>





    </main>

  </div>

</template>

<script lang="js">
  
  
  export default {
    name: 'fundacion',
  }
    
  </script>


<style lang="scss">
  
  </style>


// WEBPACK FOOTER //
// src/components/views/la-fundacion.vue